<div class="zonasegura-container">
  <header class="zonasegura-header">
    <h1>Zona segura - Participantes</h1>
    <div class="usuario-actions" *ngIf="usuario">
      <span class="usuario-nombre">{{ nombreUsuario }}</span>
      <button pButton type="button" label="Cerrar sesión" icon="pi pi-sign-out" class="p-button-outlined"
        (click)="cerrarSesion()"></button>
    </div>
  </header>
  <main class="zonasegura-content">
    <p-card>
      <ng-template pTemplate="header">
        <div class="card-header">Bienvenido a la zona de participantes</div>
      </ng-template>
      <p>Has iniciado sesión con Microsoft Entra ID. Esta área está protegida y es exclusiva para participantes.</p>
      <p *ngIf="usuario?.username" class="text-muted">Usuario: {{ usuario.username }}</p>
    </p-card>
  </main>
</div>
